import type { ToastServiceMethods } from 'primevue/toastservice';

export const useToastService: () => ToastServiceMethods = (): ToastServiceMethods => {
  const { vueApp } = useNuxtApp();
  return vueApp.config.globalProperties.$toast;
};
